export const CancelFileUploadRoute = "file-upload/cancel";
